import { render, staticRenderFns } from "./Property2.vue?vue&type=template&id=afe716a4&scoped=true"
import script from "./Property2.vue?vue&type=script&lang=js"
export * from "./Property2.vue?vue&type=script&lang=js"
import style0 from "./Property2.vue?vue&type=style&index=0&id=afe716a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe716a4",
  null
  
)

export default component.exports